export const DASHBOARD_PATH = '/dashboard';
export const MY_READING_PATH = '/my-reading';



// WEBPACK FOOTER //
// ./src/route-constants.ts